export default function(ctx, inject) {
  inject('tenant', {
    get active() {
      return 'cookos-meals'
    }
  })
}
